import React, { useEffect, useState } from 'react'
import { useApp } from '@/core/contexts/app'
import type { CategoryProps } from './types'
import { categoryEnum } from './definations'
import Select, { SelectOption } from '@/components/base/select'
import Button from '@/components/base/button'
import Image from '@/components/base/image'
import { Column, Container, Row } from '@/components/base/gridview'
import { Rings } from 'react-loading-icons'

const Category: React.FunctionComponent<CategoryProps> = ({
  image,
  title,
  desc,
}) => {
  const app = useApp()
  const [selectedOption, setSelectedOption] = useState<any>('')
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = () => {
    setIsLoading(true)
    if (selectedOption) {
      window.location.href = `${selectedOption}`
    }
  }
  return (
    <div className="form background-container">
      <div
        className="form_container"
        style={{
          maxWidth: '400px',
        }}
      >
        <Container>
          <Row>
            <Column>
              <div className="form_logo">
                <img
                  src={`https://cdn.tga.net.tr/${image?.src}`}
                  alt=""
                  width={image?.width || 200}
                  height={image?.height}
                />
                {/* {image && <Image {...image} alt={title} loading="eager" />} */}
              </div>
            </Column>
          </Row>
          <Row>
            <Column>
              <div className="form_title">
                <h4>{title}</h4>
                <p>{desc} </p>
              </div>
            </Column>
          </Row>
          <Row>
            <Column>
              <div className="input-container">
                <select
                  className="form-style"
                  style={{ width: '100%' }}
                  onChange={(e: any) => setSelectedOption(e.target.value)}
                >
                  {categoryEnum.map((item: any, key: any) => (
                    <option key={key} value={item.value}>
                      {item.text}
                    </option>
                  ))}
                </select>
              </div>
            </Column>
          </Row>
          <Row>
            {isLoading ? (
              <Column>
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                  <Rings stroke="#4a90e2" strokeWidth={4} />
                </div>
              </Column>
            ) : (
              <Column>
                <div className="form_button">
                  <Button appearance="default" onClick={handleClick}>
                    Seçimi Kaydet
                  </Button>
                </div>
              </Column>
            )}
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Category
